/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';

/**
 * 
 * @export
 * @interface CreateDataDialogPromptRequestContent
 */
export interface CreateDataDialogPromptRequestContent {
    /**
     * 
     * @type {string}
     * @memberof CreateDataDialogPromptRequestContent
     */
    promptText: string;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof CreateDataDialogPromptRequestContent
     */
    callingIdentity: CallingIdentity;
}


/**
 * Check if a given object implements the CreateDataDialogPromptRequestContent interface.
 */
export function instanceOfCreateDataDialogPromptRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "promptText" in value;
    isInstance = isInstance && "callingIdentity" in value;

    return isInstance;
}

export function CreateDataDialogPromptRequestContentFromJSON(json: any): CreateDataDialogPromptRequestContent {
    return CreateDataDialogPromptRequestContentFromJSONTyped(json, false);
}

export function CreateDataDialogPromptRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDataDialogPromptRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'promptText': json['promptText'],
        'callingIdentity': CallingIdentityFromJSON(json['callingIdentity']),
    };
}

export function CreateDataDialogPromptRequestContentToJSON(value?: CreateDataDialogPromptRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'promptText': value.promptText,
        'callingIdentity': CallingIdentityToJSON(value.callingIdentity),
    };
}

